/* eslint-disable no-restricted-globals */

/**
 * A globális JSON ki lett tiltva, de ha valami oknál fogva (ezen a csomagon kívül) használni kéne, akkor
 * be lehet húzni így is.
 */
const nativeJSON = JSON

module.exports.nativeJSON = nativeJSON
